/**
 * Palantir PMS - Software para la gestión de la industria hotelera
 * Palantir PMS - Software for hotel industry management
 * Autor / Author: Alberto Castro Ull
 * Fecha de creación / Created on: 31/07/2025
 * Todos los derechos reservados / All rights reserved.
 * Este software es propiedad de Alberto Castro Ull.
 * This software is the property of Alberto Castro Ull.
 * Su uso está restringido a clientes con licencia emitida por Markulia Group, S.L.
 * Use is restricted to clients licensed by Markulia Group, S.L.
 */

import React, { useEffect } from "react";
import CustomerForm from "../Components/CustomerForm";
import axios from "../api/axiosInstance";

const GuestsColumn = ({
  isSummary,
  formData,
  showNewCustomerForm,
  bookerData,
  isEditingAnyRole,
  customerFormData,
  handleCustomerChange,
  handleCustomerCountryChange,
  editingAccompanyingIndex,
  editingChildIndex,
  requiredCustomerFieldsReservation,
  handleSubmitChild,
  handleSubmitCustomer,
  handleCancel,
  reservationIdRef,
  customerData,
  setCustomerFormData,
  setShowNewCustomerForm,
  setBookerData,
  setEditingAccompanyingIndex,
  setEditingChildIndex,
  guestCustomers,
  reservationId,
  setGuestCustomers,
  handleSelectAccompanyingGuest,
  handleAddNewAccompanyingGuest,
  handleRemoveAccompanyingGuest,
  handleSelectChild,
  handleAddNewChild,
  handleRemoveChild,
  guestChildren,
  setGuestChildren,
  customerIdFromURL,
  navigate,
  searchParams,
  businessUnitId,
  setCustomerData,
  selectedReservationId,
  groupReservations,
  onOpenBookerSelector,
  onOpenMainGuestSelector,
  onOpenAccompanyingSelector,
  onOpenChildSelector


}) => {

    console.log("🔵 groupReservations:", groupReservations);

    const hasAnyDate =
  (formData.check_in_date && formData.check_in_date !== "") ||
  (formData.check_out_date && formData.check_out_date !== "");

const hasRequiredOccupancy =
  (formData.adults && Number(formData.adults) > 0) || 
  (formData.children !== undefined && Number(formData.children) >= 0);

const hasRoomCategory =
  formData.room_category_id && formData.room_category_id !== "";

const hasRoomRate =
  (formData.rate_id && formData.rate_id !== "") ||
  (formData.group_rate_id && formData.group_rate_id !== "");

// Si hay fechas pero falta alguno de estos: adults, children, category o tarifa → deshabilitar.
const disableBookerButton = hasAnyDate && (!hasRequiredOccupancy || !hasRoomCategory || !hasRoomRate);

console.log("➡️ Disable booker button?", disableBookerButton, {
  formData,
  hasAnyDate,
  hasRequiredOccupancy,
  hasRoomCategory,
  hasRoomRate,
});



    console.log(
    "🔎 GuestsColumn render → selectedReservationId:",
    selectedReservationId,
    "isSummary:",
    isSummary
    );

    // Calcula el array según el contexto activo
    let requiredFields;
    if (showNewCustomerForm === "booker") {
    requiredFields = requiredCustomerFieldsReservation?.booker || [];
    } else if (showNewCustomerForm === true) {
    requiredFields = requiredCustomerFieldsReservation?.main_guest || [];
    } else if (
    typeof showNewCustomerForm === "string" &&
    showNewCustomerForm.startsWith("accompanying-")
    ) {
    requiredFields = requiredCustomerFieldsReservation?.accompanying || [];
    } else if (
    typeof showNewCustomerForm === "string" &&
    showNewCustomerForm.startsWith("child-")
    ) {
    requiredFields = requiredCustomerFieldsReservation?.child || [];
    } else if (editingAccompanyingIndex !== null) {
    requiredFields = requiredCustomerFieldsReservation?.accompanying || [];
    } else if (editingChildIndex !== null) {
    requiredFields = requiredCustomerFieldsReservation?.child || [];
    } else {
    requiredFields = requiredCustomerFieldsReservation?.main_guest || [];
    }



useEffect(() => {
  if (
    bookerData &&                               // Hay un booker seleccionado
    requiredCustomerFieldsReservation?.booker && // Hay campos requeridos
    showNewCustomerForm !== "booker"            // No está ya abierto el formulario de booker
  ) {
    const missingFields = requiredCustomerFieldsReservation.booker.filter(
      (field) => !bookerData[field] || String(bookerData[field]).trim() === ""
    );
    if (missingFields.length > 0) {
      setCustomerFormData({ ...bookerData });
      setShowNewCustomerForm("booker");
    }
  }
}, [bookerData, requiredCustomerFieldsReservation, showNewCustomerForm]);

useEffect(() => {
  if (
    customerData &&
    requiredCustomerFieldsReservation?.main_guest &&
    requiredCustomerFieldsReservation.main_guest.length > 0
  ) {
    // Filtro para saber si le faltan campos obligatorios
    const missingFields = requiredCustomerFieldsReservation.main_guest.filter(
      (field) =>
        !customerData[field] ||
        (typeof customerData[field] === "string" && customerData[field].trim() === "")
    );

    if (missingFields.length > 0) {
      // Solo abre el formulario si no está ya abierto para main guest
      if (showNewCustomerForm !== true) {
        setCustomerFormData(customerData);
        setShowNewCustomerForm(true);
      }
    }
  }
  // Solo debe ejecutarse cuando cambia el main guest o settings de campos requeridos
}, [customerData, requiredCustomerFieldsReservation?.main_guest, showNewCustomerForm]);

// ⚡️ Autoabrir edición si algún acompañante está incompleto y el formulario NO está ya abierto
useEffect(() => {
  if (!Array.isArray(guestCustomers)) return;

  // Busca el primer acompañante con campos requeridos faltantes
  const indexToEdit = guestCustomers.findIndex((guest, idx) => {
    if (!guest) return false;
    const required = requiredCustomerFieldsReservation?.accompanying || [];
    return required.some(field => !guest[field] || guest[field].toString().trim() === "");
  });

  // Si hay un acompañante incompleto y no estamos editando ninguno, abrimos el formulario de ese slot
  if (
    indexToEdit !== -1 &&
    editingAccompanyingIndex === null &&
    showNewCustomerForm !== `accompanying-${indexToEdit}`
  ) {
    // ⚠️ Evita doble render: abre solo si no está ya abierto
    setCustomerFormData(guestCustomers[indexToEdit]);
    setEditingAccompanyingIndex(indexToEdit);
    setTimeout(() => {
      setShowNewCustomerForm(`accompanying-${indexToEdit}`);
    }, 0);
  }
}, [
  guestCustomers,
  requiredCustomerFieldsReservation,
  editingAccompanyingIndex,
  showNewCustomerForm,
  setCustomerFormData,
  setEditingAccompanyingIndex,
  setShowNewCustomerForm
]);

// ⚡️ Autoabrir edición si algún niño está incompleto y el formulario NO está ya abierto
useEffect(() => {
  if (!Array.isArray(guestChildren)) return;

  // Busca el primer niño con campos requeridos faltantes
  const indexToEdit = guestChildren.findIndex((child, idx) => {
    if (!child) return false;
    const required = requiredCustomerFieldsReservation?.child || [];
    return required.some(field => !child[field] || child[field].toString().trim() === "");
  });

  // Si hay un niño incompleto y no estamos editando ninguno, abrimos el formulario de ese slot
  if (
    indexToEdit !== -1 &&
    editingChildIndex === null &&
    showNewCustomerForm !== `child-${indexToEdit}`
  ) {
    setCustomerFormData(guestChildren[indexToEdit]);
    setEditingChildIndex(indexToEdit);
    setTimeout(() => {
      setShowNewCustomerForm(`child-${indexToEdit}`);
    }, 0);
  }
}, [
  guestChildren,
  requiredCustomerFieldsReservation,
  editingChildIndex,
  showNewCustomerForm,
  setCustomerFormData,
  setEditingChildIndex,
  setShowNewCustomerForm
]);

    

  return (
    <div style={{ flex: 1 }}>

    {/* 🔵 Tarjeta del BOOKER */}
    <div className="card bg-dark text-light p-4 mb-3"
        style={{
        fontSize: "0.85rem",
        zoom: "80%",
        width: "90%",
        maxWidth: "100%",
        marginLeft: "30px",
        marginRight: "20px"
        }}
    >
        {!isEditingAnyRole(showNewCustomerForm) && <h3 className="text-info">Booker Information</h3>}

        {isEditingAnyRole(showNewCustomerForm) ? (
        <div className="bg-dark text-white p-3 border border-warning rounded text-center">
            <strong>
            Please add customer details for{" "}
            <span className="text-warning">
                {showNewCustomerForm === true
                ? "main guest"
                : showNewCustomerForm === "booker"
                ? "booker"
                : typeof showNewCustomerForm === "string" && showNewCustomerForm.startsWith("accompanying-")
                ? `accompanying guest ${parseInt(showNewCustomerForm.split("-")[1], 10) + 1}`
                : typeof showNewCustomerForm === "string" && showNewCustomerForm.startsWith("child-")
                ? `child ${parseInt(showNewCustomerForm.split("-")[1], 10) + 1}`
                : "guest"}
            </span>.
            </strong>
        </div>
        ) : !bookerData ? (
        <div className="d-flex gap-3">
            <button
                type="button"
                onClick={() => {
                    if (!disableBookerButton && typeof onOpenBookerSelector === "function") {
                        onOpenBookerSelector();   // 🚀 abrir popup definido en NewReservation.jsx
                    }
                }}
                disabled={disableBookerButton}
                className="btn fw-bold border-0 px-4 py-2"
                style={{
                    background: "linear-gradient(to right, #1abc9c, #3498db)",
                    color: "white",
                    borderRadius: "5px",
                    opacity: disableBookerButton ? 0.4 : 1,
                    cursor: disableBookerButton ? "not-allowed" : "pointer"
                }}
                title={
                    disableBookerButton
                    ? "You can't add/select a booker while there are reservations with dates but no rate."
                    : "Select Booker"
                }
            >
                Select Booker
            </button>



            <button
            type="button"
            onClick={() => {
                setCustomerFormData({
                first_name: "",
                last_name: "",
                middle_name: "",
                second_last_name: "",
                email: "",
                phone: "",
                address: "",
                postal_code: "",
                country: "",
                city: "",
                gender: "",
                birth_date: "",
                document_type: "",
                document_number: "",
                is_vip: false,
                vip_description: "",
                photo_url: "",
                level: "",
                });
                setShowNewCustomerForm("booker");
            }}
            disabled={disableBookerButton}
            className="btn fw-bold border-0 px-4 py-2"
            style={{
                background: "linear-gradient(to right, #9b59b6, #8e44ad)",
                color: "white",
                borderRadius: "5px",
                 opacity: disableBookerButton ? 0.4 : 1,
                cursor: disableBookerButton ? "not-allowed" : "pointer",
            }}
            title={
                disableBookerButton
                ? "You can't add/select a booker while there are reservations with dates but no rate."
                : "Add Booker"
            }
            >
            Add Booker
            </button>
        </div>
        ) : (
        <div className="p-3 bg-secondary rounded d-flex justify-content-between align-items-start gap-4">
            <div>
            <p><strong>Name:</strong> {bookerData.first_name} {bookerData.last_name}</p>
            <p><strong>Email:</strong> {bookerData.email || "N/A"}</p>
            <p><strong>Phone:</strong> {bookerData.phone || "N/A"}</p>                    
            </div>
            <div className="d-flex flex-column gap-2 mt-1">
            <button
                onClick={() => {
                setCustomerFormData({ ...bookerData });
                setShowNewCustomerForm("booker");
                }}
                disabled={disableBookerButton}
                style={{
                padding: "4px 12px",
                fontSize: "0.75rem",
                border: "none",
                borderRadius: "4px",
                color: "#fff",
                fontWeight: "bold",
                background: "linear-gradient(to right, #00C9A7, #5B2C6F)",
                opacity: disableBookerButton ? 0.4 : 1,
                cursor: disableBookerButton ? "not-allowed" : "pointer",
                }}
                
            >
                Edit
            </button>
            <button
            onClick={async () => {
                const groupId = formData.reservation_group_id;
                if (!groupId) {
                alert("No reservation group ID found.");
                return;
                }

                try {
                console.log("🧪 Enviando PATCH para borrar booker del grupo:", groupId);
                await axios.patch(`${process.env.REACT_APP_API_URL}/api/reservation-drafts/draft-groups/${groupId}`, {
                booker_id: null,
                updated_by: "UserRemove",
                });

                console.log("✅ Booker eliminado correctamente del draft");
                setBookerData(null);
                } catch (err) {
                console.error("❌ Error eliminando booker del grupo:", err);
                alert("Error removing booker.");
                }
            }}
            disabled={disableBookerButton}
            style={{
                padding: "4px 12px",
                fontSize: "0.75rem",
                border: "none",
                borderRadius: "4px",
                color: "#fff",
                fontWeight: "bold",
                background: "linear-gradient(to right, #ffcc00, #cc3300)",
            }}
            title="Remove booker"
            >
            Remove
            </button>

            </div>
        </div>
        )}
    </div>

    
    {!bookerData && (
        <div style={{ height: "44px" }} />
    )}

    


{selectedReservationId !== "summary" && (
<>
    {showNewCustomerForm || editingAccompanyingIndex !== null || editingChildIndex !== null ? (
    <div
        className="card bg-dark text-light p-4"
        style={{
        fontSize: "0.85rem",
        zoom: "80%",
        width: "fit-content",
        maxWidth: "92%",
        marginLeft: "25px",
        marginRight: "20px"
        }}
    >
        <h3 className="text-warning">
        New Customer{" "}
        {typeof showNewCustomerForm === "string" && showNewCustomerForm.startsWith("accompanying-")
            ? `– Accompanying guest #${parseInt(showNewCustomerForm.split("-")[1], 10) + 1}`
            : typeof showNewCustomerForm === "string" && showNewCustomerForm.startsWith("child-")
            ? `– Child #${parseInt(showNewCustomerForm.split("-")[1], 10) + 1}`
            : ""}
        </h3>




        <CustomerForm
            formData={customerFormData}
            handleChange={handleCustomerChange}
            handleSelectChange={handleCustomerCountryChange}
            requiredFields={
                showNewCustomerForm === "booker"
                ? requiredCustomerFieldsReservation?.booker || []
                : showNewCustomerForm === true
                ? requiredCustomerFieldsReservation?.main_guest || []
                : typeof showNewCustomerForm === "string" && showNewCustomerForm.startsWith("accompanying-")
                ? requiredCustomerFieldsReservation?.accompanying || []
                : typeof showNewCustomerForm === "string" && showNewCustomerForm.startsWith("child-")
                ? requiredCustomerFieldsReservation?.child || []
                : editingAccompanyingIndex !== null
                ? requiredCustomerFieldsReservation?.accompanying || []
                : editingChildIndex !== null
                ? requiredCustomerFieldsReservation?.child || []
                : requiredCustomerFieldsReservation?.main_guest || []
            }
            />

        <div className="d-flex justify-content-between gap-2 mt-3">
        <button
            type="button"
            onClick={() => {
                console.log("[DEBUG] Save Changes → showNewCustomerForm:", showNewCustomerForm);
                console.log("[DEBUG] Save Changes → editingAccompanyingIndex:", editingAccompanyingIndex);
                handleSubmitCustomer(requiredFields);
            }}
            className="btn btn-sm fw-bold px-3 py-1"
            style={{
                background: "linear-gradient(to right, #17a2b8, #006d91)",
                color: "white",
                border: "none",
                borderRadius: "5px",
                width: "30%"
            }}
        >
            Save Changes
        </button>



        <button 
            type="button" 
            onClick={handleCancel}
        
            className="btn btn-sm fw-bold px-3 py-1"
            style={{
            background: "linear-gradient(to right, #9b59b6, #8e44ad)",
            color: "white",
            border: "none",
            borderRadius: "5px",
            width: "30%"
            }}
        >
            Cancel Changes
        </button>

        {/* Remove */}
        <button
            type="button"
            onClick={async () => {
            const reservationId = reservationIdRef.current;
            const isBooker = showNewCustomerForm === "booker" || (editingAccompanyingIndex === null && editingChildIndex === null && bookerData?.id === customerFormData?.id);
            const isMainGuest = showNewCustomerForm === true || (editingAccompanyingIndex === null && editingChildIndex === null && customerData?.id === customerFormData?.id);
            const isAccompanying = (
                (typeof showNewCustomerForm === "string" && showNewCustomerForm.startsWith("accompanying-")) ||
                (editingAccompanyingIndex !== null && guestCustomers[editingAccompanyingIndex]?.id === customerFormData?.id)
            );
            const isChild = (
            (typeof showNewCustomerForm === "string" && showNewCustomerForm.startsWith("child-")) ||
            (editingChildIndex !== null && guestChildren[editingChildIndex]?.id === customerFormData?.id)
            );


            if (!reservationId) return;

            if (isBooker && bookerData?.id) {
                try {
                const groupId = formData.reservation_group_id;
                if (!groupId) {
                    alert("Missing reservation group ID.");
                    return;
                }

                await axios.patch(`${process.env.REACT_APP_API_URL}/api/reservation-drafts/draft-groups/${groupId}`, {
                booker_id: null,
                updated_by: "UserRemove"
                });

                

                setBookerData(null);
                setCustomerFormData({});
                setShowNewCustomerForm(false);
                console.log("🗑️ Booker eliminado del grupo");
                } catch (err) {
                console.error("❌ Error al eliminar booker:", err);
                alert("Error removing booker");
                }

                return;
            }

            if (isMainGuest && customerData?.id) {
            try {
                await axios.delete(
                `${process.env.REACT_APP_API_URL}/api/reservation-drafts/draft-guests/by-draft/${selectedReservationId}/main-guest`
                );
                console.log("🗑️ Main guest eliminado del draft (reservation_draft_guests)");

                setCustomerData(null);
                setCustomerFormData({});
                setShowNewCustomerForm(false);

                const params = new URLSearchParams(window.location.search);
                params.delete("customer_id");
                navigate(`/new-reservation/${selectedReservationId}?${params.toString()}`, { replace: true });
            } catch (error) {
                console.error("❌ Error al eliminar main guest (draft):", error);
                alert("Error removing main guest.");
            }
            return;
            }


            if (isAccompanying) {
                const index = editingAccompanyingIndex !== null
                    ? editingAccompanyingIndex
                    : parseInt((showNewCustomerForm || "").split("-")[1], 10);

                const guest = guestCustomers[index];
                const customerId = guest?.customer_id || guest?.id || guest?.customer?.id;

                if (!customerId) {
                    console.warn("❌ No se pudo determinar el ID del cliente accompanying");
                    return;
                }

                try {
                    await axios.delete(
                    `${process.env.REACT_APP_API_URL}/api/reservation-drafts/draft-guests/by-draft/${reservationId}/by-customer/${customerId}`
                    );

                    const updated = [...guestCustomers];
                    updated[index] = undefined;
                    setGuestCustomers(updated);
                    setCustomerFormData({});
                    setShowNewCustomerForm(false);
                    setEditingAccompanyingIndex(null);
                    console.log("🗑️ Acompañante eliminado correctamente (DRAFT)");
                } catch (err) {
                    console.error("❌ Error al eliminar accompanying guest (DRAFT):", err);
                    alert("Error removing accompanying guest");
                }

                return;
                }


            if (isChild && editingChildIndex !== null && guestChildren[editingChildIndex]?.id) {
            const customerId = guestChildren[editingChildIndex].id;

            try {
                await axios.delete(
                `${process.env.REACT_APP_API_URL}/api/reservation-drafts/draft-guests/by-draft/${reservationId}/by-customer/${customerId}/child?guest_index=${editingChildIndex}`
                );

                console.log("🗑️ Child eliminado del backend (DRAFT)");

                const updated = [...guestChildren];
                updated[editingChildIndex] = undefined;
                setGuestChildren(updated);
                setCustomerFormData({});
                setShowNewCustomerForm(false);
                setEditingChildIndex(null);
            } catch (err) {
                console.error("❌ Error al eliminar child (DRAFT):", err);
                alert("Error removing child");
            }

            return;
            }


            // 🆕 Remove desde Add Customer sin ID
            if (!customerFormData?.id) {
                console.log("🧼 Remove desde Add Customer → cerrando formulario");
                setCustomerFormData({
                first_name: "",
                last_name: "",
                middle_name: "",
                second_last_name: "",
                email: "",
                phone: "",
                address: "",
                postal_code: "",
                country: "",
                city: "",
                gender: "",
                birth_date: "",
                document_type: "",
                document_number: "",
                is_vip: false,
                vip_description: "",
                photo_url: "",
                level: "",
                });
                setShowNewCustomerForm(false);
                return;
            }


            console.warn("⚠️ Remove pressed, but role is neither booker nor main guest");
            }}

            className="btn btn-sm fw-bold px-3 py-1"
            style={{
            background: "linear-gradient(to right, #ffcc00, #cc3300)",
            color: "white",
            border: "none",
            borderRadius: "5px",
            width: "30%"
            }}
        >
            Remove
        </button>
        </div>
        
        </div>
        
    
    ) : (
    <>
    

        {/* 🟡 Tarjeta PRINCIPAL del cliente */}
        <div
        className="card bg-dark text-light p-4 mb-3"
        style={{
            fontSize: "0.85rem",
            zoom: "80%",
            width: "90%",
            maxWidth: "100%",
            marginLeft: "30px",
            marginRight: "20px"
        }}
        >
        <h3 className="text-warning">Customer Information</h3>

        {!(formData.rate_id || formData.group_rate_id) ? (
            <div
            className="bg-dark border border-secondary text-white text-center fw-bold py-3 px-3 rounded"
            style={{
                fontSize: "0.9rem",
                backgroundColor: "#222",
                marginTop: "10px",
                marginBottom: "10px"
            }}
            >
            Waiting for room rate to be selected before assigning guests.
            </div>
        ) : (

        formData.adults ? (
            customerData ? (
            <div className="p-3 bg-secondary rounded d-flex justify-content-between align-items-start gap-4">
                <div>
                <p><strong>Name:</strong> {customerData.first_name} {customerData.last_name}</p>
                <p><strong>Email:</strong> {customerData.email || "N/A"}</p>
                <p><strong>Phone:</strong> {customerData.phone || "N/A"}</p>                        
                </div>

                <div className="d-flex align-items-start gap-3">
                <div>
                    <img
                    src={customerData.photo_url || "/default-avatar.png"}
                    alt="Customer"
                    style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                        borderRadius: "10px",
                        border: "2px solid #ddd"
                    }}
                    onError={(e) => {
                        if (e.target.src !== window.location.origin + "/default-avatar.png") {
                        e.target.src = "/default-avatar.png";
                        }
                    }}
                    />
                </div>

                <div className="d-flex flex-column gap-2 mt-1">
                    <button
                    onClick={() => {
                        setCustomerFormData({ ...customerData });
                        setShowNewCustomerForm(true);
                    }}
                    style={{
                        padding: "4px 12px",
                        fontSize: "0.75rem",
                        border: "none",
                        borderRadius: "4px",
                        color: "#fff",
                        fontWeight: "bold",
                        background: "linear-gradient(to right, #00C9A7, #5B2C6F)",
                    }}
                    title="Edit customer"
                    >
                    Edit
                    </button>

                    <button
                    onClick={async () => {
                        const pathMatch = window.location.pathname.match(/\/new-reservation\/(\d+)/);
                        const reservationId = pathMatch ? pathMatch[1] : null;

                        // ✅ Draft ID real (lo que estás usando ya en esta pantalla)
                        const draftId = selectedReservationId || reservationId;

                        // ✅ Mantén TU forma de leer BU (para que no te traiga customers de otras BU)
                        const businessUnitId = searchParams.get("business_unit_id") || "1";

                        if (!draftId) return;

                        try {
                        // 1) borrar main guest de la tabla nueva de drafts
                        await axios.delete(
                            `${process.env.REACT_APP_API_URL}/api/reservation-drafts/draft-guests/by-draft/${draftId}/main-guest`,
                            { params: { business_unit_id: businessUnitId } }
                        );

                        // 2) limpiar estado UI
                        setCustomerData(null);

                        // 3) limpiar query y recargar vista
                        searchParams.delete("customer_id");
                        const newSearch = searchParams.toString();
                        navigate(`/new-reservation/${draftId}?${newSearch}`, { replace: true });
                        } catch (error) {
                        console.error("❌ Error al eliminar main guest:", error);
                        alert("Error removing main guest");
                        }
                    }}
                    style={{
                        padding: "4px 12px",
                        fontSize: "0.75rem",
                        border: "none",
                        borderRadius: "4px",
                        color: "#fff",
                        fontWeight: "bold",
                        background: "linear-gradient(to right, #ffcc00, #cc3300)",
                    }}
                    title="Remove customer"
                    >
                    Remove
                    </button>

                </div>
                </div>
            </div>
            ) : (
            <>
            
            {bookerData?.id && (
                <div className="d-flex justify-content-end align-items-center mb-2">
                <div style={{ position: "absolute", top: "10px", right: "20px", zIndex: 10 }}>
                    <div className="form-check" style={{ marginBottom: 0 }}>
                    <input
                        key={`same-as-booker-${formData.id || "no-id"}`}
                        className="form-check-input"
                        type="checkbox"
                        id="sameAsBookerCheckbox"
                        style={{ transform: "scale(0.9)", cursor: "pointer" }}
                        onChange={async (e) => {
                        if (!e.target.checked) return;

                        const pathMatch = window.location.pathname.match(/\/new-reservation\/(\d+)/);
                        const reservationId = pathMatch ? parseInt(pathMatch[1], 10) : null;

                        if (!reservationId) {
                            alert("Missing reservation ID.");
                            return;
                        }

                        try {
                            console.log("🧪 Launching 'Same as booker' with:");
                            console.log("   reservation_id:", reservationId);
                            console.log("   booker_id (customer_id):", bookerData?.id);

                            await axios.post(`${process.env.REACT_APP_API_URL}/api/reservation-drafts/draft-guests`, {
                            reservation_draft_id: Number(selectedReservationId),
                            customer_id: bookerData.id,
                            is_main_guest: true,
                            is_child: false,
                            guest_index: null,
                            relationship: null
                            });


                            const { data: reloadedCustomer } = await axios.get(`${process.env.REACT_APP_API_URL}/api/customers/${bookerData.id}`);
                            setCustomerData(reloadedCustomer);
                            console.log("✅ Booker assigned as main guest and reloaded:", reloadedCustomer);
                        } catch (err) {
                            const status = err.response?.status;
                            const backendError = err.response?.data?.error;

                            if (status === 409) {
                            alert(
                                backendError ||
                                "❌ This customer is already assigned to another reservation with overlapping dates. Cannot assign them as main guest."
                            );
                            return;
                            }

                            console.error("❌ Failed to assign booker as main guest:", err);
                            alert("❌ An unexpected error occurred while assigning the booker as main guest.");
                        }

                        }}
                    />
                    <label
                        className="form-check-label text-white"
                        htmlFor="sameAsBookerCheckbox"
                        style={{ fontSize: "0.75rem", marginLeft: "6px" }}
                    >
                        Same as booker
                    </label>
                    </div>
                </div>
                </div>
            )}


            
            <div className="d-flex gap-3">
                <button
                    type="button"
                    onClick={() => {
                        if (typeof onOpenMainGuestSelector === "function") {
                        onOpenMainGuestSelector();   // 🚀 abre el popup en vez de navegar
                        }
                    }}
                    className="btn fw-bold border-0 px-4 py-2"
                    style={{
                        background: "linear-gradient(to right, #1abc9c, #3498db)",
                        color: "white",
                        borderRadius: "5px"
                    }}
                    >
                    Select Customer
                    </button>


                <button
                type="button"
                onClick={() => {
                    setCustomerFormData({
                    first_name: "",
                    last_name: "",
                    middle_name: "",
                    second_last_name: "",
                    email: "",
                    phone: "",
                    address: "",
                    postal_code: "",
                    country: "",
                    city: "",
                    gender: "",
                    birth_date: "",
                    document_type: "",
                    document_number: "",
                    is_vip: false,
                    vip_description: "",
                    photo_url: "",
                    level: "",
                    });

                    const match = window.location.pathname.match(/\/new-reservation\/(\d+)/);
                    const reservationId = match ? match[1] : null;

                    if (!reservationId) {
                    alert("No reservation ID found.");
                    return;
                    }

                    navigate(`/new-reservation/${reservationId}?business_unit_id=${businessUnitId}`, { replace: true });

                    setTimeout(() => {
                    setEditingAccompanyingIndex(null);
                    setEditingChildIndex(null);
                    setShowNewCustomerForm(true);
                    }, 100);
                }}
                className="btn fw-bold border-0 px-4 py-2"
                style={{
                    background: "linear-gradient(to right, #9b59b6, #8e44ad)",
                    color: "white",
                    borderRadius: "5px"
                }}
                >
                Add Customer
                </button>
            </div>
            </>  
           )
            ) : null
        )}
        </div>

        {/* 🔵 Tarjeta para acompañantes y niños */}
        {(formData.rate_id || formData.group_rate_id) && (formData.adults > 1 || formData.children > 0) && (
        <div
            className="card bg-dark text-light p-4"
            style={{
            fontSize: "0.85rem",
            zoom: "80%",
            width: "90%",
            maxWidth: "100%",
            marginLeft: "30px",
            marginRight: "20px"
            }}
        >                  
            {/* 🔁 Acompañantes adultos mejorados */}
            {formData.adults > 1 &&
            Array.from({ length: formData.adults - 1 }).map((_, index) => {
                const guest = guestCustomers[index];
                const customer = guest?.customer || guest;

                return (
                <div key={`accompanying-${index}`} className="mb-3">
                    <h5 className="text-info mb-2">Accompanying Guest #{index + 1}</h5>

                    {!customer ? (
                    <div className="d-flex gap-2 mt-2">
                        <button
                            onClick={() => {
                                if (typeof onOpenAccompanyingSelector === "function") {
                                onOpenAccompanyingSelector(index);
                                }
                            }}
                            className="btn btn-sm fw-bold px-3 py-1"
                            style={{
                                background: "linear-gradient(to right, #1abc9c, #3498db)",
                                color: "white",
                                border: "none",
                                borderRadius: "5px"
                            }}
                            >
                            Select Customer
                            </button>

                        <button
                        onClick={() => {
                            handleAddNewAccompanyingGuest(index);
                            console.log("[DEBUG] Abriendo formulario de accompanying guest: index =", index);
                            setShowNewCustomerForm(`accompanying-${index}`);
                        }}
                        className="btn btn-sm fw-bold px-3 py-1"
                        style={{
                            background: "linear-gradient(to right, #9b59b6, #8e44ad)",
                            color: "white",
                            border: "none",
                            borderRadius: "5px"
                        }}
                        >
                        Add Customer
                        </button>
                    </div>
                    ) : (
                    <div className="d-flex justify-content-between align-items-center p-2 border bg-secondary rounded text-light">
                        <div>
                        
                        <p className="mb-0">
                            <strong>{customer.first_name} {customer.last_name}</strong> — <span style={{ fontSize: "0.75rem" }}>{customer.email || "No email"}</span>
                        </p>
                        </div>

                        <div className="d-flex gap-2 align-items-start">
                        <button
                            onClick={() => {
                            setCustomerFormData({ ...customer });
                            setEditingAccompanyingIndex(index);
                            }}
                            style={{
                            padding: "4px 10px",
                            fontSize: "0.7rem",
                            border: "none",
                            borderRadius: "4px",
                            color: "#fff",
                            fontWeight: "bold",
                            background: "linear-gradient(to right, #00C9A7, #5B2C6F)",
                            }}
                        >
                            Edit
                        </button>

                        <button
                            onClick={() => handleRemoveAccompanyingGuest(index)}
                            style={{
                            padding: "4px 10px",
                            fontSize: "0.7rem",
                            border: "none",
                            borderRadius: "4px",
                            color: "#fff",
                            fontWeight: "bold",
                            background: "linear-gradient(to right, #ffcc00, #cc3300)",
                            }}
                        >
                            Remove
                        </button>
                        </div>
                    </div>

                    )}
                </div>
                );
            })}






            {/* 👶 Niños */}
            {formData.children > 0 &&
            Array.from({ length: formData.children }).map((_, index) => {
                const guest = guestChildren[index];
                const customer = guest?.customer ?? guest ?? null;

                return (
                <div key={`child-${index}`} className="mb-3">
                    <h5 className="text-warning mb-2">Child #{index + 1}</h5>

                    {!customer ? (
                    <div className="d-flex gap-2 mt-2">
                        <button
                        onClick={() => {
                            if (typeof onOpenChildSelector === "function") {
                            onOpenChildSelector(index);
                            }
                        }}
                        className="btn btn-sm fw-bold px-3 py-1"
                        style={{
                            background: "linear-gradient(to right, #1abc9c, #3498db)",
                            color: "white",
                            border: "none",
                            borderRadius: "5px"
                        }}
                        >
                        Select Customer
                        </button>

                        <button
                        onClick={() => {
                            handleAddNewChild(index);
                            setShowNewCustomerForm(`child-${index}`);
                        }}
                        className="btn btn-sm fw-bold px-3 py-1"
                        style={{
                            background: "linear-gradient(to right, #9b59b6, #8e44ad)",
                            color: "white",
                            border: "none",
                            borderRadius: "5px"
                        }}
                        >
                        Add Customer
                        </button>
                    </div>
                    ) : (
                    <div className="d-flex justify-content-between align-items-center p-2 border bg-secondary rounded text-light">
                        <div>
                        <p className="mb-0">
                            <strong>{customer.first_name} {customer.last_name}</strong> — <span style={{ fontSize: "0.75rem" }}>{customer.email || "No email"}</span>
                        </p>
                        </div>
                        <div className="d-flex gap-2 align-items-start">
                        <button
                            onClick={() => {
                            setCustomerFormData({ ...customer });
                            setEditingChildIndex(index);
                            }}
                            style={{
                            padding: "4px 10px",
                            fontSize: "0.7rem",
                            border: "none",
                            borderRadius: "4px",
                            color: "#fff",
                            fontWeight: "bold",
                            background: "linear-gradient(to right, #00C9A7, #5B2C6F)",
                            }}
                        >
                            Edit
                        </button>
                        <button
                            onClick={() => handleRemoveChild(index)}
                            style={{
                            padding: "4px 10px",
                            fontSize: "0.7rem",
                            border: "none",
                            borderRadius: "4px",
                            color: "#fff",
                            fontWeight: "bold",
                            background: "linear-gradient(to right, #ffcc00, #cc3300)",
                            }}
                        >
                            Remove
                        </button>
                        </div>
                    </div>
                    )}
                </div>
                );
            })}



        </div>
        )}
    </>
    
    )}
    </>
)}

    
</div>
        
  );
};

export default GuestsColumn;
